// extracted by mini-css-extract-plugin
module.exports = {"container":"rLZNC","adjust":"rvfya","stories":"v78V4","heading":"I_DUB","headingLarge":"S6EGG"};